__turbopack_context__.v({
  "add": "cBMilG_add",
  "card": "cBMilG_card",
  "cardList": "cBMilG_cardList",
  "div": "cBMilG_div",
  "text": "cBMilG_text",
});
